<cm-select-dialog
    [data]="$data()"
    (selectItem)="onSelectItem($event)"
    (cancel)="cancelDialog()"
    [title]="'Select material'"
    [pageFilledStatusChange]="pageFilledStatusChange$"
    [gridSize]="$gridSize()"
>
    <ng-container cm-filters>
        <cm-search (valueChange)="searchText$.next($event)" placeholder="Name, description, ..."></cm-search>
        <cm-own-organizations-filter [locked]="$lockOrganization()" (selectionChanged)="organizationsIds$.next($event)"></cm-own-organizations-filter>
    </ng-container>
</cm-select-dialog>
